import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-682edc78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy-section" }
const _hoisted_2 = {
  key: 0,
  class: "policy-field"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "⚠️[Renewal]", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "policy-field" }
const _hoisted_6 = { class: "policy-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Product:", -1))
const _hoisted_8 = { class: "policy-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_10 = { class: "policy-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Period:", -1))
const _hoisted_12 = { class: "policy-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Term:", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Download Policy Doc")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Download Audit Summary")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Download Cancel Endorsement")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Download NOC")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Download Non-Renew Doc")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Certificate of Insurance", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Complete the following fields to customize the COI:", -1))
const _hoisted_27 = { class: "input-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Description of Operations:")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Certificate holder details", -1))
const _hoisted_30 = { class: "input-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "certHolderName" }, "Name:", -1))
const _hoisted_32 = { class: "input-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "addressLine1" }, "Address Line 1:", -1))
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "addressLine2" }, "Address Line 2:", -1))
const _hoisted_36 = { class: "input-row" }
const _hoisted_37 = { class: "input-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City:", -1))
const _hoisted_39 = { class: "input-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State abbreviation:", -1))
const _hoisted_41 = { class: "input-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "zipCode" }, "Zip Code:", -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Generate COI")
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showRenewalNote)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.policyNumber), 1),
    _createElementVNode("span", _hoisted_6, [
      _hoisted_7,
      _createTextVNode(" " + _toDisplayString(_ctx.product), 1)
    ]),
    _createElementVNode("span", _hoisted_8, [
      _hoisted_9,
      _createTextVNode(" " + _toDisplayString(_ctx.status), 1)
    ]),
    _createElementVNode("span", _hoisted_10, [
      _hoisted_11,
      _createTextVNode(" " + _toDisplayString(_ctx.period), 1)
    ]),
    _createElementVNode("span", _hoisted_12, [
      _hoisted_13,
      _createTextVNode(" " + _toDisplayString(_ctx.term), 1)
    ]),
    (_ctx.hasDocuments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", null, [
            (_ctx.hasAvailablePolicyDoc)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.downloadPolicyDocument()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_15,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.auditSummaryStatus === 'available')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.downloadAuditSummary()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_16,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.auditSummaryStatus === 'unavailable')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Audit Summary Not Available"))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_ctx.hasAvailableCancellationDoc)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.downloadCancellationDocument()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_18,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.documentsList && _ctx.documentsList.Cancellation)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.downloadNoticeOfCancellation()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_19,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.documentsList && _ctx.documentsList.NonRenewal)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.downloadNonRenewal()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_20,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isDownloading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "⌛"))
            : _createCommentVNode("", true),
          (_ctx.hasDownloadError)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "❌"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCoi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _hoisted_25,
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _withDirectives(_createElementVNode("textarea", {
              id: "description",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.descriptionOfBusiness = $event)),
              rows: "3",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.descriptionOfBusiness]
            ])
          ]),
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "certHolderName",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.certHolderName = $event)),
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.certHolderName]
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "addressLine1",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.addressLine1 = $event)),
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.addressLine1]
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "addressLine2",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.addressLine2 = $event)),
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.addressLine2]
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "city",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.city = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "state",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state = $event)),
                class: "form-control",
                maxlength: "2"
              }, null, 512), [
                [_vModelText, _ctx.state]
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "zipCode",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.zip = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.zip]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            (_ctx.showCoi)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.downloadCertificateOfInsurance()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_43,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isDownloading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, "⌛"))
            : _createCommentVNode("", true),
          (_ctx.hasDownloadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, "❌"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}